module.exports = __webpack_public_path__ + "static/media/train.fa9a1f4f.svg";